/**
 * One dropdown setting, read left to right: the choice on the left, what it
 * means on the right (comms 9/23 review).
 *
 * Below the `sm` breakpoint the two columns stack, choice first, so nothing
 * scrolls sideways on a phone.
 */
import type { ReactNode } from 'react';

import { Label } from '@/components/ui/label';

export function SettingRow({
  label,
  htmlFor,
  control,
  explanation,
}: {
  label: string;
  /** id of the control's trigger, so the label focuses it. */
  htmlFor?: string;
  control: ReactNode;
  explanation: ReactNode;
}) {
  return (
    <div
      data-testid="setting-row"
      className="grid grid-cols-1 gap-2 sm:grid-cols-[minmax(0,18rem)_minmax(0,1fr)] sm:gap-4"
    >
      <div data-testid="setting-row-control" className="min-w-0">
        <Label
          htmlFor={htmlFor}
          className="text-xs font-medium uppercase text-muted-foreground"
        >
          {label}
        </Label>
        <div className="mt-1">{control}</div>
      </div>
      <div
        data-testid="setting-row-explanation"
        className="min-w-0 space-y-1 text-xs text-muted-foreground sm:pt-6"
      >
        {explanation}
      </div>
    </div>
  );
}

export default SettingRow;
